import { IPredictiveModel } from '~src/predictiveModel/serverApi/types/IPredictiveModel';
import { IGetItemsParams } from '~src/ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/ts/ServerApi/types/IGetItemsResult';
import { IUser } from '~src/ts/ServerApi/types/IUser';
import { INamedItem } from '~src/ts/ServerApi/types/resourceParts';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetPredictiveModelsParams extends IGetItemsParams {
}

export interface IGetPredictiveModelsResult extends IGetItemsResult {
  predictiveModels?: IPredictiveModel[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetPredictiveModelsRequest extends Request<IGetPredictiveModelsParams, IGetPredictiveModelsResult> {
  constructor(params: IGetPredictiveModelsParams) {
    super('getPredictiveModels', params);
  }
}
